module.exports = __webpack_public_path__ + "img/ship-4.9688095f.jpg";